import { IMarginValue, MarginValue } from './margin-value.model';
import { IPassengerTypeConfig, PassengerTypeConfig } from './passenger-type-config.model';

export interface IPackageV1 {
  id?: string;
  companyId?: string;
  reference?: string;
  /** First margin applied, global to the package (not per passenger type). */
  firstMargin?: IMarginValue;
  /** Second margin, applied after firstMargin (cumulative). */
  secondMargin?: IMarginValue;
  surcharge?: IPassengerTypeConfig;
  /** Per-package currency-rate overrides (EUR is the implicit reference = 1, never sent as a key). */
  exchangeRates?: { [currency: string]: number };
  currency?: string;
  /** Groups of prestation ids (backend resolves/stores ids only, not full prestation objects). */
  prestationGroups?: string[][];
  createdAt?: string;
  updatedAt?: string;
}

export class PackageV1 implements IPackageV1 {
  constructor(
    public id?: string,
    public companyId?: string,
    public reference?: string,
    public firstMargin?: MarginValue,
    public secondMargin?: MarginValue,
    public surcharge?: PassengerTypeConfig,
    public currency?: string,
    public prestationGroups?: string[][],
    public createdAt?: string,
    public updatedAt?: string,
    public exchangeRates?: { [currency: string]: number }
  ) {
    this.prestationGroups = this.prestationGroups || [];
  }
}
